module.exports = __webpack_public_path__ + "static/media/samplecreds.5d6e50d1.xlsx";